import { render, staticRenderFns } from "./AlterRole.vue?vue&type=template&id=e979a224&scoped=true&"
import script from "./AlterRole.vue?vue&type=script&lang=js&"
export * from "./AlterRole.vue?vue&type=script&lang=js&"
import style0 from "./AlterRole.vue?vue&type=style&index=0&id=e979a224&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e979a224",
  null
  
)

export default component.exports